module.exports = __webpack_public_path__ + "static/media/term-show.7122cfe6.png";